export class SetOrderLocked {
	static readonly type = '[Quality][Order][Detail] SetOrderLocked';

	constructor(
		public locked: Date,
		public lockedBy: {
			firstName: string;
			id: string;
			lastName: string;
		}
	) {}
}

export class SetOrderUnlocked {
	static readonly type = '[Quality][Order][Detail] SetOrderUnlocked';
}
